import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { coreReducer } from '../core.reducer';
import { userReducer } from '../../user/store/user.reducer';
import { formReducer } from '@ispm/dynamic-form/store/form.reducer';
import { sharedReducer } from '../../shared/store/shared.reducer';
import { testSummaryReducer } from '@ispm/test/store/test-summary.reducer';
import { aberrationsReducer } from '@ispm/aberrations/store/aberrations.reducer';
import { testMetaReducer } from '@ispm/test/store/test-meta.reducer';
import { diagnosticOrderReducer } from '@ispm/test/store/diagnostic-order.reducer';
import { aberrationsMetaReducer } from '@ispm/aberrations/store/aberrations-meta.reducer';
import { FindingsReducer } from '@ispm/test/store/findings.reducer';
import { curationReducer } from '../../curation/store/curation.reducer';
import { reportPreviewReducer } from '@ispm/test/store/report-preview.reducer';
import { testBarReducer } from '@ispm/test/store/test-bar.reducer';
import { InjectionToken } from '@angular/core';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { brandsReducer } from '../../brands/store/brands.reducer';
import {
  currentMDTConfigReducer
} from '@ispm-client/modules/widgets/components/decision-tree-capture/store/current-mdt-configurations.reducer';
import { currentOrderReducer } from '@ispm/test/store/current-order.reducer';
import { iamFoundationReducer } from '../../../ispm-admin/iamFoundation/reducer/iamFoundation.reducer';
import { analyticsReducer } from '@ispm-client/modules/analytics/store/reducer/analytics.reducer';
import { webMessagesReducer } from '@ispm/core/store/webMessages.reducer';

export const genomicsState = {
  core: coreReducer,
  users: userReducer,
  currentMDTConfig: currentMDTConfigReducer,
  currentOrder: currentOrderReducer,
  analytics: analyticsReducer,
  forms: formReducer,
  brands: brandsReducer,
  shared: sharedReducer,
  curation: curationReducer,
  tests: combineReducers({
    aberrations: combineReducers({
      data: aberrationsReducer,
      meta: aberrationsMetaReducer
    }),
    findings: FindingsReducer,
    testSummary: testSummaryReducer,
    reportPreview: reportPreviewReducer,
    meta: testMetaReducer,
    diagnosticOrders: diagnosticOrderReducer,
    testBar: testBarReducer
  }),
  iamFoundation: iamFoundationReducer,
  webMessages: webMessagesReducer
};

export const reducerToken = new InjectionToken<ActionReducerMap<IgenomicsState>>('Reducers');

export function getReducers() {
  return genomicsState;
}

export const reducerProvider = [
  { provide: reducerToken, useFactory: getReducers }
];
